import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import api from '../../../app/api/api';
import { KitchenFormModel } from '../../../app/data/models/kitchens/kitchenFormModel';

export const fetchKitchenDetailsAsync = createAsyncThunk<
  KitchenFormModel,
  { restaurantId: string; kitchenId: string }
>('kitchen/fetchDetails', async ({ restaurantId, kitchenId }, thunkAPI) => {
  try {
    return await api.Kitchen.details(restaurantId, kitchenId);
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkAPI.rejectWithValue({ error: error.response?.data });
    }
    return thunkAPI.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const kitchenDetailsSlice = createSlice({
  name: 'kitchenDetails',
  initialState: {
    kitchen: null as KitchenFormModel | null,
    status: 'idle',
  },
  reducers: {
    clearKitchenDetails: (state) => {
      state.kitchen = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchKitchenDetailsAsync.pending, (state) => {
      state.status = 'pendingFetchDetails';
    });
    builder.addCase(fetchKitchenDetailsAsync.fulfilled, (state, action) => {
      state.kitchen = action.payload;
      state.status = 'idle';
    });
    builder.addCase(fetchKitchenDetailsAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});

export const { clearKitchenDetails } = kitchenDetailsSlice.actions;
